import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { AssetContext } from '@pages/Asset/Asset.query';
import { useContext } from 'react';

export const AddPhotoButton = () => {
  const { setShowAdd } = useContext(AssetContext);

  return (
    <BActionIcon
      icon="plus"
      onClick={() => {
        setShowAdd(true);
      }}
    />
  );
};
